module.exports = __webpack_public_path__ + "img/fiveday1-1.fe0d10d8.jpg";